import { apiFetch, invalidateCsrfToken } from './client'

export interface AuthStatus {
  setupCompleted: boolean
}

export interface CurrentUser {
  email: string
  passkeyCount: number
}

export interface PasskeySummary {
  credentialId: string
  name: string
  createdAt: string
  isBackedUp: boolean
}

export const authApi = {
  status: () => apiFetch<AuthStatus>('/api/auth/status'),

  setup: (email: string, password: string) =>
    apiFetch<{ email: string }>('/api/auth/setup', {
      method: 'POST',
      body: { email, password },
    }),

  login: (email: string, password: string) =>
    apiFetch<{ email: string }>('/api/auth/login', {
      method: 'POST',
      body: { email, password },
    }).then((r) => {
      // CSRF-token är identitetsbunden — hämta ny efter inloggning.
      invalidateCsrfToken()
      return r
    }),

  logout: () =>
    apiFetch<void>('/api/auth/logout', { method: 'POST' }).then(() => {
      invalidateCsrfToken()
    }),

  me: () => apiFetch<CurrentUser>('/api/auth/me'),

  // Passkeys
  passkeys: () => apiFetch<PasskeySummary[]>('/api/auth/passkeys'),

  passkeyCreationOptions: () =>
    apiFetch<PublicKeyCredentialCreationOptionsJSON>('/api/auth/passkey/creation-options', {
      method: 'POST',
    }),

  passkeyRegister: (credentialJson: string, name?: string) =>
    apiFetch<void>('/api/auth/passkey/register', {
      method: 'POST',
      body: { credentialJson, name },
    }),

  passkeyRequestOptions: () =>
    apiFetch<PublicKeyCredentialRequestOptionsJSON>('/api/auth/passkey/request-options', {
      method: 'POST',
    }),

  passkeyLogin: (credentialJson: string) =>
    apiFetch<void>('/api/auth/passkey/login', {
      method: 'POST',
      body: { credentialJson },
    }).then((r) => {
      invalidateCsrfToken()
      return r
    }),

  passkeyRemove: (credentialId: string) =>
    apiFetch<void>(`/api/auth/passkeys/${encodeURIComponent(credentialId)}`, {
      method: 'DELETE',
    }),
}
